import React from 'react';

type CategoryType = {
  name: string;
  value: string | number | boolean;
};

type ProfileCardProps = {
  title?: string;
  categories?: CategoryType[];
};

const ProfileCard: React.FC<ProfileCardProps> = ({ title, categories }) => {
  return (
    <div className='mx-auto min-w-[672px]' style={{ margin: 0 }}>
      <div className='bg-white shadow sm:rounded-lg'>
        <div className='px-4 py-5 sm:px-6'>
          <h3 className='text-lg font-medium leading-6 text-gray-900'>
            {title}
          </h3>
        </div>
        <div className='border-t border-gray-200 px-4 py-5 sm:px-6'>
          <dl className='grid grid-cols-1 gap-x-4 gap-y-6 sm:grid-cols-2'>
            {categories?.map((category, index) => (
              <div key={index} className='sm:col-span-1'>
                <dt className='text-sm font-medium text-gray-500'>
                  {category.name}
                </dt>
                <dd className='mt-1 text-sm text-gray-900'>
                  {' '}
                  {category.value}
                </dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </div>
  );
};

export default ProfileCard;
